export default "__VITE_ASSET__a46ff9a0__"